import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "up-arrow",
  "use": "up-arrow-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"up-arrow\"><path d=\"M507.333 424.604h-.01c-34.073-69.917-91.188-169.063-141.594-256.521-26.396-45.833-51.323-89.104-69.344-121.979-8.5-15.521-23.604-24.771-40.396-24.771s-31.896 9.25-40.396 24.771c-18.01 32.875-42.917 76.104-69.292 121.896C95.885 255.5 38.76 354.667 4.667 424.604 1.573 430.979 0 437.708 0 444.604 0 470 20.51 490.667 45.729 490.667L256 490.625l210.271.042C491.49 490.667 512 470 512 444.604c0-6.896-1.573-13.625-4.667-20z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/up-arrow.svg
// module id = H2uT
// module chunks = 1